/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: 乱数,ランダム,random
 * note:
 *  - ランダムを使うユーティリティ群
 *  - ランダム文字列の生成
 *  - 整数の乱数を出力する
 *  - 与えられた配列の中からランダムに一つの要素を取り出す
 * sample:
 *  -
 * :ZNOTE:
 */

import generator from 'generate-password-ts';

/**
 * ランダム文字列を出力する
 * @param num
 */
export const getRandomStr = (num: number) =>
  generator.generate({length: num, numbers: true, uppercase: true, lowercase: true, strict: false});

/**
 * 整数の乱数を出力する
 * @param min
 * @param max
 */
export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
};

/**
 * 与えられた配列の中からランダムに一つの要素を取り出す
 * @param array
 */
export const randomPickFromArray = (array: any[]) =>
  array[getRandomInt(0, array.length)];


/**
 * 与えられた配列の順番をシャッフルする
 * @param array {any[]}
 * @param shuffleCount {number} シャッフル回数(デフォルトは1周)
 */
export const shuffleArray = (array: any[], shuffleCount=1) => {
  for (let k=0; k<shuffleCount; k++) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = getRandomInt(0, i + 1);
      [array[i], array[j]] = [array[j], array[i]];
    }
  }
  return array;
};
